import { UserInfoViewModel } from "./user-info.viewmodel";

export class UpdateInfoViewModel {
  constructor(
    readonly lastServerUpdate: Date | null,
    readonly lastLocalUpdate: Date | null,
    readonly lastEditedByUser: UserInfoViewModel | null) {
  }

  toString(): string {
    return `LastServerUpdate: ${this.lastServerUpdate}, LastLocalUpdate: ${this.lastLocalUpdate}, LastEditedByUser: ${this.lastEditedByUser}`;
  }
}
